import { FormGroup, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export const requiredIfValidator = (sourceControlName: string): ValidatorFn => {
  return (group: AbstractControl): ValidationErrors | null => {
    const sourceChecked = group.get(sourceControlName)?.value;
    const targetControl = group.get('apotexSettlementClass');

    const targetControl2 = group.get('heritageSettlementClass');
    const targetControl3 = group.get('sunTaroSettlementClass');


    // If source is checked, the target must also be true
    if (!sourceChecked && !targetControl?.value && !targetControl2?.value && !targetControl3?.value) {
      return { requiredIfFailed: true };
    }

    return null;
  };
};
